module.exports = __webpack_public_path__ + "static/media/icon-clipboard-check.89873077.svg";